import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, API } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWhatsapp from "@/components/FloatingWhatsapp";

export default function PublicPlayer() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/players/public/${slug}`).then((r) => setP(r.data)).catch(() => setErr("Player not found"));
  }, [slug]);
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />
      <div className="max-w-4xl mx-auto px-6 pt-28 pb-24">
        {err && <div className="text-center text-white/60">{err}</div>}
        {p && (
          <div className="p-8 md:p-10 bg-gradient-to-br from-[#0B132B] to-[#151F3D] border border-[#39FF14]/30 rounded-lg glow-green">
            <div className="text-xs uppercase tracking-[0.4em] text-[#39FF14]">NDPL Approved Player</div>
            <h1 className="font-display text-5xl md:text-7xl mt-3">{p.name}</h1>
            <div className="mt-3 text-[#FFD700] font-display text-2xl">#{p.registration_number}</div>
            <div className="mt-8 grid md:grid-cols-3 gap-4">
              {[["Role", p.role],["Tehsil", p.tehsil],["Jersey", p.jersey_size],["Age", p.age],["Trial No.", p.trial_number || "TBD"]].map(([l,v]) => (
                <div key={l} className="p-4 bg-black/30 border border-white/10">
                  <div className="text-[10px] uppercase tracking-widest text-white/50">{l}</div>
                  <div className="font-display text-xl mt-1">{v}</div>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <img src={`${API}/players/${p.id}/qr`} alt="qr" className="w-40 h-40 bg-white p-2" />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
